import { render, staticRenderFns } from "./MonthlyScoreInsertResult.vue?vue&type=template&id=f65531d0&"
import script from "./MonthlyScoreInsertResult.vue?vue&type=script&lang=js&"
export * from "./MonthlyScoreInsertResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports